/**
 * StorageKey — Enum key dùng cho localStorage / sessionStorage
 * Dùng khi gọi window.localStorage.getItem(StorageKey.JP_TOKEN)
 * CreatedBy: dbhuan (14/06/2026)
 */
export const StorageKey = {
  /** JetPay access token — localStorage */
  JP_TOKEN: "_jp_Token",
  /** JetPay user info — localStorage */
  JP_USER: "_jp_User",
  /** JetPay merchant status — localStorage */
  JP_MERCHANT_STATUS: "_jp_MerchantStatus",
  /** JetPay current merchant — localStorage */
  JP_CURRENT_MERCHANT: "_jp_CurrentMerchant",
  /** JetPay AMIS session ID — localStorage */
  JP_AMPL_SID: "_jp_AmplSid",
  /** MISA current user — localStorage */
  MS_CURRENT_USER: "MS_CurrentUser",
  /** Vai trò người dùng — localStorage */
  ROLE_LOCAL: "RoleLocal",
  /** Loại đăng nhập — localStorage */
  LOGIN_PROVIDER: "loginProvider",
  /** Trạng thái collapse sidebar — sessionStorage */
  MENU_COLLAPSE: "menu-collapse",
  JP_SOCKET_TOKEN: "_jp_socket_token",
};
